import React from "react";
import "./consolidated-sources.scss";

const label = (value) => String(value || "-").replace(/_/g, " ");

export default function ConsolidatedSources({ records = [] }) {
  if (records.length <= 1) return null;

  const consolidatedCount = records.length - 1;

  return (
    <details className="consolidated-sources">
      <summary className="consolidated-sources__heading">
        <span className="consolidated-sources__title">
          <span className="consolidated-sources__chevron">›</span>
          <strong>Consolidated Details</strong>
        </span>
        <span>{consolidatedCount} consolidated</span>
      </summary>

      <div className="consolidated-sources__content">
        <div className="consolidated-sources__grid">
          {records.map((record) => (
            <div className="consolidated-sources__card" key={record.id}>
              <div>
                <strong>{record.source_name}</strong>
                <span className={`consolidated-sources__decision consolidated-sources__decision--${record.decision}`}>
                  {label(record.decision)}
                </span>
              </div>
              <p>{record.title || "Untitled source record"}</p>
              <dl>
                <div><dt>Method</dt><dd>{label(record.match_method)}</dd></div>
                <div><dt>Match</dt><dd>{Math.round(Number(record.match_score || 0) * 100)}%</dd></div>
                <div><dt>Matched fields</dt><dd>{record.matched_fields?.length ? record.matched_fields.join(", ") : "-"}</dd></div>
              </dl>
              {record.source_url && <a href={record.source_url} target="_blank" rel="noreferrer">Open source ↗</a>}
            </div>
          ))}
        </div>
      </div>
    </details>
  );
}
